const FNC9_Download_Log = "/v1/download-log"
const FNC9_Get_Batch_Logs = "/v1/batch-log"
const FNC9_Run_Batch = "/v1/run-batch"

export const BATCH_ENDPOINT = {
  FNC9_Download_Log,
  FNC9_Get_Batch_Logs,
  FNC9_Run_Batch,
}
